import axios, { AxiosRequestConfig } from "axios";

export const fetchAPI = async (url: string, options?: AxiosRequestConfig) => {
  try {
    const response = await axios(url, options);

    if (!response.data) {
      // console.log("Request not ok...", response);
    }

    const data = await response.data;

    return data;
  } catch (error) {
    // console.log("error from fetch.ts", error);
    throw error;
  }
};

export const fetchAPINative = async (url: string, options?: RequestInit) => {
  try {
    const response = await fetch(url, options);
    if (!response.ok) {
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
    // return error;
  }
};
